import * as styledComponents from "styled-components";
import { ThemeInterface } from "./theme";

const {
    default: styled,
    createGlobalStyle,
    css,
    keyframes,
    withTheme,
    ThemeProvider,
} = styledComponents as styledComponents.ThemedStyledComponentsModule<ThemeInterface>;

export type PropsWithTheme<P extends object> = P & { theme: ThemeInterface };

export { css, createGlobalStyle, keyframes, withTheme, ThemeProvider };

export default styled;
